<template>
    <div class="flex rounded-25 bg-a-gray-e9ecf5 text-20 h-full">
        <div  v-for="(l,i) in language" :key="i" @click="toggleSwitch(l.value)"
            class="flex-1 text-center"
            :class="active == l.value ? activeClass : 'text-a-blue-1c3e95'">
            <div class="pt-1 sm:pt-2">{{ l.text }}</div>
        </div>
    </div>
</template>
<script>
import Locale from '@/helper/locale/Locale'; 
import AuthStatusMixin from "@/mixin/AuthStatusMixin"; 
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "SwitchLang",
    mixins: [ AuthStatusMixin, LocaleMixin ],
    props: {
        lang: { type: [String,Number],default: 1054 }, // v-model:check
    },
    data: function(){
        return {
            language: [],
            active: null
        }
    },
    computed:{
        activeClass(){
            return 'bg-a-blue-1c3e95 text-white rounded-25 border-white'
        }
    },
    created: function(){
        this.active = Locale.getLocaleCode();
        this.language = [
            {text: this.active == 1054 ? 'ไทย' : 'TH' , value: 1054},
            {text: 'EN' , value: 1033},
        ];
    },
    methods: {
        toggleSwitch: function(lang) {
            this.active = lang; 
            this.lbl = Locale.getLbl();
    
            this.switchLang(lang);
        }, 
    },
}
</script>
<style lang="scss" scoped>
</style>
